import { getToken, setToken, removeToken } from '@/utils/auth'

const user = {
  state: {
    token: getToken(),
    name: '',
    avatar: '',
  },

  mutations: {
    SET_TOKEN: (state, token) => {
    	setToken(token)
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    }
  },

  actions: {
    // 登录
   /* Login({ commit }, userInfo) {
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        login(username, userInfo.password).then(response => {
          const data = response.data
          setToken(data.token)
          commit('SET_TOKEN', data.token)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },*/
   
  /*  setSwitchTabsValue({ commit }, { val }) {
      commit('SET_SWITCH_TABS', val)
    },*/

    // 获取用户信息
  /*  GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo(state.token).then(response => {
          const res = response.data
          if(res.code==200){
	          if(res.data.permissions && res.data.permissions.length > 0) { // 验证返回的roles是否是一个非空数组
	            commit('SET_PERMISSIONS', res.data.permissions)
	          } else {
	            reject('用户未分配权限，登录无效！')
	          }
	          commit('SET_NAME', res.data.name)
	          //commit('SET_AVATAR', res.data.avatar)
	          commit('SET_AVATAR', res.data.avatar)
	          commit('SET_COMMUNITY',res.data.community)
          }
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },*/

    // 登出
/*    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_PERMISSIONS', [])
          commit('SET_COMMUNITY', 0)
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },*/

    // 前端 登出
   /* FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        commit('SET_COMMUNITY', 0)
        removeToken()
        resolve()
      })
    }*/
  }
}

export default user
